<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Vendor</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Loyalty Point System</b> / 
      <router-link :to="{name: 'vendor-view'}">Vendor List</router-link> /
      <router-link :to="{name: 'product-request-update', params: { id: vendor_id }}">Product List</router-link> /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px;">
      <span><b>Date Taken:</b> {{ created_at }}</span>
    </div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              <b>Product & Services Details</b>
            </h4>
            <br>

            <div class="row">
              <div class="col-4">
                <label style="margin-bottom: 10px; font-weight: bold">Name: </label> {{ product.name }}
                <br />
                <label style="font-weight: bold">Image: </label>
                <br />
                <img :src="src" width="50%" style="margin-bottom: 20px;" />

                <br />

                <label style="font-weight: bold">Description: </label>
                <br />
                <label style="margin-bottom: 30px;"> {{ product.description }} </label>
              </div>

              <div class="col-4">
                <label style="margin-bottom: 10px; font-weight: bold">Quantity: </label> {{ product.quantity }}
                <br />
                <label style="margin-bottom: 10px; font-weight: bold"> Price:  </label> $ {{ product.price }}
                <br />
                <label style="margin-bottom: 10px; font-weight: bold"> TBM Point:  </label> {{ product.point }}
                <br />
                <label style="margin-bottom: 10px; font-weight: bold"> Activation Status:  </label> <br>
                <label class="radio-inline" v-if="product.active == 1">
                      <label class="radio radio-success">
                          <input type="radio" name="active" value="1" v-model="product.active" checked>
                          <span>Active</span>
                          <span class="checkmark"></span>
                      </label>
                  </label>

                  <label class="radio-inline" v-else>
                      <label class="radio radio-danger">
                          <input type="radio" name="active" value="0" v-model="product.active" checked>
                          <span>Inactive</span>
                          <span class="checkmark"></span>
                      </label>
                  </label>
              </div>

              <div class="col-4">
                <label style="font-weight: bold">Promotion Duration: </label>
                <br />
                <!-- <label style="margin-bottom: 30px;"> Limited </label> -->
                <label class="radio-inline" v-if="product.promotion == 1">
                    <label class="radio radio-warning">
                        <input type="radio" name="promotion" value="1" v-model="product.promotion" checked>
                        <span>Unlimited</span>
                        <span class="checkmark"></span>
                    </label>
                </label>

                <label class="radio-inline" v-else>
                    <label class="radio radio-warning">
                        <input type="radio" name="promotion" value="0" v-model="product.promotion" checked>
                        <span>Limited</span>
                        <span class="checkmark"></span>
                    </label>
                </label>

                <br />
                <input type="text" disabled v-model="product.promotion_start">
                <br />
                <div class="col-3" style="text-align: center">
                  <label style="margin-top: 5px;"> to </label>
                </div>
                <input type="text" disabled v-model="product.promotion_end">
              </div>
              <div class="col-12">
                <label style="font-weight: bold">Give Remarks: </label>
                <input type="text" class="form-control" style="margin-bottom: 10px;" v-model="product.remarks" />
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
                <span class="col-3"></span>
                <button class="btn btn-lg btn-success  col-2" @click="approve(product.id)">Approve</button>
                <span class="col-2"></span>
                <button class="btn btn-lg btn-danger col-2" @click="resubmit(product.id)">Request Resubmit</button>
                <span class="col-3"></span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment"


export default {
  name: "product_details",

  data() {
    return {
      product: [],
      src: "",
      created_at: "",
      vendor_id: ''
    };
  },

  methods: {
    async loadDetails() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      // check if has token
        if (token !== null) {
            token = JSON.parse(token);
            token = token.access_token;
        }

        axios.get(axios.lpsURL + "/vendor_product/get/" + id, {
            headers: {
            Authorization: "Bearer " + token
            }
        })
        .then(res => {
          this.product = res.data.product;
          this.loadImage(token)

          this.created_at = moment(this.product.created_at).format("DD/MM/YYYY")
        })
    },

    loadImage(token) {
      let id = this.$route.params.id;

      axios.get(axios.lpsURL + "/vendor_product/show/" + id, {
          headers: {
            Authorization: "Bearer " + token
          },
          responseType: "blob"
        })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.src = reader.result
          };
        })

    },

    approve(id){
      let token = localStorage.getItem("token");
      let vendor_id = this.$route.params.vendor_id;

      // check if has token
        if (token !== null) {
            token = JSON.parse(token);
            token = token.access_token;
        }

        swal({
          icon: 'warning',
          text: 'Are you sure?',
          buttons: ['Cancel', 'Yes']
        }).then((confirm) => {
          if(!confirm) {
            return;
          }
          axios.post(axios.lpsURL + "/vendor_product/approve/" + id, 
          {
            
          },
          {
              headers: {
              Authorization: "Bearer " + token
              }
          })
          .then(res => {
              swal({
                title: "Success",
                icon: "success",
                text: res.data.message
              })
              .then(() => {
                this.$router.push("/lps/vendor/product/" + vendor_id)
              })
          })
        })

    },

    resubmit(id){
      let token = localStorage.getItem("token");
      let vendor_id = this.$route.params.vendor_id;

      // check if has token
        if (token !== null) {
            token = JSON.parse(token);
            token = token.access_token;
        }
        swal({
          icon: 'warning',
          text: 'Are you sure?',
          buttons: ['Cancel', 'Yes']
        }).then((confirm) => {
          if(!confirm) {
            return;
          }
          axios.post(axios.lpsURL + "/vendor_product/reject/" + id, 
          {
            remarks: this.product.remarks
          },
          {
              headers: {
              Authorization: "Bearer " + token
              }
          })
          .then(res => {
              swal({
                title: "Success",
                icon: "success",
                text: res.data.message
              })
              .then(() => {
                this.$router.push("/lps/vendor/product/" + vendor_id)
              })
          })
        })
    }
  },

  mounted() {
    this.loadDetails();
    this.vendor_id = this.$route.params.vendor_id;
    console.log(this.$route.params.vendor_id)
  }
};
</script>
